import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { GB, GR } from "country-flag-icons/react/3x2";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import LanguageIcon from "@mui/icons-material/Language";
import { StyledIconButton } from "./StyledComponents";
import ListItemIcon from "@mui/material/ListItemIcon";
import { useNavigate, useLocation } from "react-router-dom";

export default function LanguageSelector() {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    setAnchorEl(null);
  };

  const selectLanguage = (language) => {
    const hasPrefix = /^\/(en|el)(\/|$)/.test(location.pathname);
    const basePath = hasPrefix
      ? location.pathname.replace(/^\/(en|el)/, `/${language}`)
      : `/${language}${location.pathname}`;
    const newPath = `${basePath}${location.search}${location.hash}`;
    i18n.changeLanguage(language);
    navigate(newPath, { replace: true });
    setAnchorEl(null);
  };

  return (
    <>
      <StyledIconButton
        aria-label="languages"
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <LanguageIcon />
      </StyledIconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem
          onClick={() => selectLanguage("en")}
          sx={{ color: "#20242A" }}
          selected={i18n.language === "en"}
        >
          <ListItemIcon style={{ marginRight: "20px" }}>
            <GB title="English" style={{ width: 30 }} />
          </ListItemIcon>
          English
        </MenuItem>
        <MenuItem
          onClick={() => selectLanguage("el")}
          sx={{ color: "#20242A" }}
          selected={i18n.language === "el"}
        >
          <ListItemIcon style={{ marginRight: "20px" }}>
            <GR title="Greek" style={{ width: 30 }} />
          </ListItemIcon>
          Ελληνικά
        </MenuItem>
      </Menu>
    </>
  );
}
